import { render } from "./HuntersList.vue?vue&type=template&id=3c4f6ca2"
import script from "./HuntersList.vue?vue&type=script&lang=js"
export * from "./HuntersList.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/felipe_admin_sr/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__